/** InsCoder WANG.J 2026-09-17 B + Reveal native MP4 controls after manual playback starts **/
(function () {
  'use strict';

  if (document.documentElement.dataset.pdpVideoControlsInitialized === 'true') return;
  document.documentElement.dataset.pdpVideoControlsInitialized = 'true';

  function getControlsTrigger(event) {
    if (!event.target || typeof event.target.closest !== 'function') return null;

    var trigger = event.target.closest('[data-pdp-video-controls-trigger]');

    if (!trigger || !trigger.closest('[data-pdp-video-player]')) return null;

    return trigger;
  }

  function startVideo(event, trigger) {
    var player = trigger.closest('[data-pdp-video-player]');
    var video = player ? player.querySelector('video') : null;

    if (!video) return;

    event.preventDefault();
    event.stopPropagation();
    video.controls = true;
    trigger.hidden = true;

    var playPromise = video.play();

    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        video.controls = true;
      });
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var trigger = getControlsTrigger(event);

      if (trigger) startVideo(event, trigger);
    },
    true
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var trigger = getControlsTrigger(event);

      if (trigger) startVideo(event, trigger);
    },
    true
  );
})();
/** InsCoder WANG.J 2026-09-17 E + Reveal native MP4 controls after manual playback starts **/
